// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"78":"dab78bad","338":"95147a2e","489":"9b71bb34","541":"9fd0c552","544":"e8ed27fc","576":"5d209f29","753":"075cfa0f","775":"34842616","823":"0fb06780"}[chunkId] + ".js";
};